/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Care_LogsInputs */

const vi_nav_care_logs = /** @type {(inputs: Nav_Care_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký chăm sóc`)
};

/**

* @param {Nav_Care_LogsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_care_logs = /** @type {((inputs?: Nav_Care_LogsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Care_LogsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_care_logs(inputs)
});